export const GET_REGION_BY_ID_CACHE_KEY = 'region_by_id';
export const GET_MAP_INFRASTRUCTURE_KEY = 'infrastructure';

export const DEFAULT_CACHE_TIMEOUT = 86400;
